import type {
  ConversaIndicador,
  DirecaoMensagem,
  StatusConversa,
} from '@/types/homeConversas/types';

export const deriveIndicador = (input: {
  status: StatusConversa;
  direction: DirecaoMensagem;
}): ConversaIndicador => {
  if (input.status === 'CLOSED' || input.status === 'ARCHIVED') {
    return 'encerrada';
  }
  if (input.direction === 'INBOUND') {
    return 'inquilino-respondeu';
  }
  return 'aguardando-retorno';
};
